[
  {
    "code": "AZ-ABS",
    "name": "Abseron"
  },
  {
    "code": "AZ-AGC",
    "name": "Agcabädi"
  },
  {
    "code": "AZ-AGM",
    "name": "Agdam"
  },
  {
    "code": "AZ-AGS",
    "name": "Agdas"
  },
  {
    "code": "AZ-AGA",
    "name": "Agstafa"
  },
  {
    "code": "AZ-AGU",
    "name": "Agsu"
  },
  {
    "code": "AZ-AST",
    "name": "Astara"
  },
  {
    "code": "AZ-BA",
    "name": "Baki"
  },
  {
    "code": "AZ-BAL",
    "name": "Balakän"
  },
  {
    "code": "AZ-BEY",
    "name": "Beyläqan"
  },
  {
    "code": "AZ-BIL",
    "name": "Biläsuvar"
  },
  {
    "code": "AZ-BAR",
    "name": "Bärdä"
  },
  {
    "code": "AZ-CAB",
    "name": "Cäbrayil"
  },
  {
    "code": "AZ-CAL",
    "name": "Cälilabab"
  },
  {
    "code": "AZ-DAS",
    "name": "Daskäsän"
  },
  {
    "code": "AZ-DAV",
    "name": "Däväçi"
  },
  {
    "code": "AZ-FUZ",
    "name": "Füzuli"
  },
  {
    "code": "AZ-GOR",
    "name": "Goranboy"
  },
  {
    "code": "AZ-GAD",
    "name": "Gädäbäy"
  },
  {
    "code": "AZ-GA",
    "name": "Gäncä"
  },
  {
    "code": "AZ-GOY",
    "name": "Göyçay"
  },
  {
    "code": "AZ-HAC",
    "name": "Haciqabul"
  },
  {
    "code": "AZ-IMI",
    "name": "Imisli"
  },
  {
    "code": "AZ-ISM",
    "name": "Ismayilli"
  },
  {
    "code": "AZ-KAL",
    "name": "Kälbäcär"
  },
  {
    "code": "AZ-KUR",
    "name": "Kürdämir"
  },
  {
    "code": "AZ-LAC",
    "name": "Laçin"
  },
  {
    "code": "AZ-LER",
    "name": "Lerik"
  },
  {
    "code": "AZ-LAN",
    "name": "Länkäran"
  },
  {
    "code": "AZ-LA",
    "name": "Länkäran Municipality"
  },
  {
    "code": "AZ-MAS",
    "name": "Masalli"
  },
  {
    "code": "AZ-MI",
    "name": "Mingäçevir"
  },
  {
    "code": "AZ-NA",
    "name": "Naftalan"
  },
  {
    "code": "AZ-NX",
    "name": "Naxçivan"
  },
  {
    "code": "AZ-NEF",
    "name": "Neftçala"
  },
  {
    "code": "AZ-OGU",
    "name": "Oguz"
  },
  {
    "code": "AZ-QAX",
    "name": "Qax"
  },
  {
    "code": "AZ-QAZ",
    "name": "Qazax"
  },
  {
    "code": "AZ-QOB",
    "name": "Qobustan"
  },
  {
    "code": "AZ-QBA",
    "name": "Quba"
  },
  {
    "code": "AZ-QBI",
    "name": "Qubadli"
  },
  {
    "code": "AZ-QUS",
    "name": "Qusar"
  },
  {
    "code": "AZ-QAB",
    "name": "Qäbälä"
  },
  {
    "code": "AZ-SAT",
    "name": "Saatli"
  },
  {
    "code": "AZ-SAB",
    "name": "Sabirabad"
  },
  {
    "code": "AZ-SAL",
    "name": "Salyan"
  },
  {
    "code": "AZ-SMI",
    "name": "Samaxi"
  },
  {
    "code": "AZ-SMX",
    "name": "Samux"
  },
  {
    "code": "AZ-SIY",
    "name": "Siyäzän"
  },
  {
    "code": "AZ-SM",
    "name": "Sumqayit"
  },
  {
    "code": "AZ-SUS",
    "name": "Susa"
  },
  {
    "code": "AZ-SS",
    "name": "Susa Municipality"
  },
  {
    "code": "AZ-SAK",
    "name": "Säki"
  },
  {
    "code": "AZ-SKR",
    "name": "Sämkir"
  },
  {
    "code": "AZ-TOV",
    "name": "Tovuz"
  },
  {
    "code": "AZ-TAR",
    "name": "Tärtär"
  },
  {
    "code": "AZ-UCA",
    "name": "Ucar"
  },
  {
    "code": "AZ-XA",
    "name": "Xankändi"
  },
  {
    "code": "AZ-XAN",
    "name": "Xanlar"
  },
  {
    "code": "AZ-XAC",
    "name": "Xaçmaz"
  },
  {
    "code": "AZ-XIZ",
    "name": "Xizi"
  },
  {
    "code": "AZ-XCI",
    "name": "Xocali"
  },
  {
    "code": "AZ-XVD",
    "name": "Xocavänd"
  },
  {
    "code": "AZ-YAR",
    "name": "Yardimli"
  },
  {
    "code": "AZ-YEV",
    "name": "Yevlax"
  },
  {
    "code": "AZ-YE",
    "name": "Yevlax Municipality"
  },
  {
    "code": "AZ-ZAQ",
    "name": "Zaqatala"
  },
  {
    "code": "AZ-ZAN",
    "name": "Zängilan"
  },
  {
    "code": "AZ-ZAR",
    "name": "Zärdab"
  },
  {
    "code": "AZ-AB",
    "name": "Äli Bayramli"
  },
  {
    "code": "AZ-SA",
    "name": "Şəki Municipality"
  }
]